define(function(require,exports,module){
	var computed=require('./dom').computed;

	var win=window,
		dens=win.devicePixelRatio || 2.0,
		splitter=/(\.\w+)$/,
		tab=768,
		large=1600,
		isDense = dens > 1,
		paths = {},
		undef;
	return {
		/* Commenting out for the meantime... not needed yet
		setPaths : function(_paths,merge){
			paths=merge ? _util.merge(paths,_paths) : _paths;
			return this;
		},
		getPaths : function(){
			return paths;
		},

		setRanges : function(_ranges,merge){
			ranges=merge ? _util.merge(ranges,_ranges) : _ranges;
			return this;
		},

		getRanges : function(){
			return ranges;
		},

		resolve : function(name,_paths){
			var usePaths=_paths || paths,
				nameParts=name.split(splitter);
			
		},
		 */
		choose : function(view,_low,_high,_superhigh){
			var isTab = win.innerWidth >=tab || win.screen.availHeight >= tab,
				isDenseTab = isTab && isDense,
				isDenseOrTab= isTab || isDense,
				ret;

			if(isDenseTab || win.innerWidth > large){
				ret= _superhigh!==undef ? _superhigh : _high;
			}
			if(ret===undef && isDenseOrTab){
				ret=_high;
			}

			return ret===undef ? _low : ret;

		}

	};


});
